import React from 'react';

import { CustomIconProps } from '../../src/utils/interfaces/Icon';

const SendIcon: React.FC<CustomIconProps> = ({
  width,
  height,
  fill,
  ...rest
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width ? width?.toString() : '24'}
      height={height ? height?.toString() : '24'}
      viewBox='0 0 24 24'
      fill={fill ? fill : 'black'}
      {...rest}
    >
      <path
        d='M7.92278 3.52487L15.0561 7.09153C18.2561 8.69153 18.2561 11.3082 15.0561 12.9082L7.92278 16.4749C3.12278 18.8749 1.16445 16.9082 3.56445 12.1165L4.28944 10.6749C4.38018 10.4629 4.42696 10.2346 4.42696 10.004C4.42696 9.77342 4.38018 9.54521 4.28944 9.3332L3.56445 7.8832C1.16445 3.09153 3.13111 1.12487 7.92278 3.52487Z'
        stroke='white'
        strokeWidth='1.5'
        strokeLinecap='round'
      />
      <path
        d='M4.53125 10H9.03125'
        stroke='white'
        strokeWidth='1.5'
        strokeLinecap='round'
      />
    </svg>
  );
};

export default SendIcon;
